function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#9CACAE",
  fillRule: "nonzero"
}, React.createElement("rect", {
  width: 8,
  height: 30,
  rx: 1
}), React.createElement("rect", {
  x: 22,
  y: 11,
  width: 8,
  height: 19,
  rx: 1
}), React.createElement("rect", {
  x: 11,
  width: 19,
  height: 8,
  rx: 1
}), React.createElement("rect", {
  x: 11,
  y: 22,
  width: 8,
  height: 8,
  rx: 1
}), React.createElement("rect", {
  x: 11,
  y: 11,
  width: 8,
  height: 8,
  rx: 1
}));

var SvgUiDesign = function SvgUiDesign(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,Cjxzdmcgdmlld0JveD0iMCAwIDMwIDMwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGcgaWQ9IkhPTUVQQUdFIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iMDEwLWlnLWhvbWUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNjMuMDAwMDAwLCAtNTQ4MC4wMDAwMDApIiBmaWxsPSIjOUNBQ0FFIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8ZyBpZD0iQ0FURUdPUklFUyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAwLjAwMDAwMCwgNTAxOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSIxMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQyOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iY29tcG9uZW50cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjMuMDAwMDAwLCAzMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1wYXRoIiB4PSIwIiB5PSIwIiB3aWR0aD0iOCIgaGVpZ2h0PSIzMCIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1wYXRoIiB4PSIyMiIgeT0iMTEiIHdpZHRoPSI4IiBoZWlnaHQ9IjE5IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLXBhdGgiIHg9IjExIiB5PSIwIiB3aWR0aD0iMTkiIGhlaWdodD0iOCIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1wYXRoIiB4PSIxMSIgeT0iMjIiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHJ4PSIxIj48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtcGF0aCIgeD0iMTEiIHk9IjExIiB3aWR0aD0iOCIgaGVpZ2h0PSI4IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgUiDesign as ReactComponent };